module.exports = __webpack_public_path__ + "img/bg103_5.4102a044.png";